(function(w, d) {
    function domReadyFunctions() {
        //Search modal functions
        function openModal(modal) {
            modal.classList.add("d-block");
            modal.classList.remove("d-none");
            modal.setAttribute("aria-hidden", "false");
          }
        
        function closeModal(modal) {
          modal.classList.remove("d-block");
          modal.classList.add("d-none");
          d.querySelector('.refine-container').focus();
          modal.setAttribute("aria-hidden", "true");
        }
        d.querySelectorAll('[data-toggle="modal"]').forEach(button => {
          button.addEventListener("click", function () {
            const targetSelector = this.getAttribute("data-target");
            const modal = d.querySelector(targetSelector);
            if (modal) openModal(modal);
          });
        });
        d.querySelectorAll(".modal-close").forEach(closeBtn => {
          closeBtn.addEventListener("click", function () {
            const modal = d.getElementById('refine-modal');
            if (modal) closeModal(modal);
          });
        });
        d.querySelectorAll(".modal").forEach(modal => {
          modal.addEventListener("click", function (e) {
            if (e.target === modal) {
              closeModal(modal);
            }
          });
        });
        //end Search modal functions
        
        //search button functions(previously inline scripts)
        /*clear fliters functionality*/
        d.querySelectorAll('.classifieds-filters blox-button').forEach(function (button) {
            button.addEventListener('click', function () {
                const parent = button.closest('.classifieds-filters');
                if (!parent) return;
          
                const clear = button.dataset.clear === 'true';
          
                
                if (clear) {
                    parent
                      .querySelectorAll('input[name^="f_"], input[name="q"]')
                      .forEach(el => el.disabled = true);
            
                    const form = parent.querySelector('.classifieds-filter-search-form');
                    if (form) form.submit();
                    return;
                }

              const dataEl =
                  button.querySelector('[data-field][data-value]') ||
                  button.querySelector('span[data-field]');
        
              if (!dataEl) return;
        
              const field = dataEl.dataset.field;
              const value = dataEl.dataset.value;
        
              const input = parent.querySelector(
                  `input[name="${field}"][value="${value}"]`
              );
        
              if (input) input.disabled = true;
        
              parent.querySelectorAll('input').forEach(el => {
                  if (el.value === '') el.disabled = true;
              });
        
              const form = parent.querySelector('.classifieds-filter-search-form');
              if (form) form.submit();
            });
        });
          
        /* side search submit upon selection*/
        d.querySelectorAll(
          '.classifieds-facet-search-form input[type=checkbox], ' +
          '.classifieds-facet-search-form input[type=radio], ' +
          '.classifieds-facet-search-form select'
        ).forEach(function (input) {
            input.addEventListener('change', function () {
              const form = input.closest('form');
              if (!form) return;
              form.submit();
            });
        });
          
        d.querySelectorAll('.classifieds-facet-search-form .facet-checkbox').forEach(function (el) {
            const selector = el.dataset.extendedContainer;
            if (!selector) return;
      
            const extendedContainer = document.querySelector(selector);
            if (!extendedContainer) return;
      
            extendedContainer.addEventListener('show.bs.collapse', function () {
                const sibling = this.parentElement.querySelector('.facet-checkboxes-show');
                if (!sibling) return;
        
                sibling.querySelector('.btn .show-text').textContent = 'Less';
                sibling.querySelector('[data-fa-i2svg]').setAttribute('data-icon', 'chevron-up');
            });
      
            extendedContainer.addEventListener('hide.bs.collapse', function () {
                const sibling = this.parentElement.querySelector('.facet-checkboxes-show');
                if (!sibling) return;
      
                sibling.querySelector('.btn .show-text').textContent = 'More';
                sibling.querySelector('[data-fa-i2svg]').setAttribute('data-icon', 'chevron-down');
            });
          });
            
        /* modal  collapsing functioality*/
        d.querySelectorAll('.refine-group-heading').forEach(function (heading) {
            heading.addEventListener('click', function () {
                const group = heading.closest('.refine-group');
                if (!group) return;
            
                const content = group.querySelector('.refine-content-wrapper');
                if (!content) return;
                const icon = heading.querySelector('blox-icon');
                const isExpanded = content.classList.contains('expanded');
          
                if (isExpanded) {
                    content.style.maxHeight = content.scrollHeight + 'px'; 
                    requestAnimationFrame(() => {
                      content.style.maxHeight = '0px';
                      content.classList.remove('expanded');
                  });
                  if (icon) {
                      icon.setAttribute('icon', 'caret-down');
                  }
                  heading.classList.remove('expanded');
              } else {
                  content.classList.add('expanded');
                  content.style.maxHeight = content.scrollHeight + 'px';
                  if (icon) {
                      icon.setAttribute('icon', 'caret-up');
                  }
                  heading.classList.add('expanded');
              }
            });
        });
        
        /* expand button functionality */
        document.querySelectorAll('.facet-checkboxes-show').forEach(trigger => {
            trigger.addEventListener('click', () => {
          
              // Collapsible element is BEFORE the trigger
              const target = trigger.previousElementSibling;
              if (!target || !target.classList.contains('collapse')) return;
          
              const isOpen = target.classList.contains('d-none');
          
              if (isOpen) {
                  trigger.querySelector('.show-text').innerText = "Less";
                  trigger.querySelector('blox-icon').icon = "chevron-up";
                  requestAnimationFrame(() => {
                    target.classList.remove('d-none');
                  });
            
                  trigger.setAttribute('aria-expanded', 'false');
              } else {
                  target.classList.add('d-none');
                  trigger.querySelector('.show-text').innerText = "More";
                  trigger.querySelector('blox-icon').icon = "chevron-down";
                  trigger.setAttribute('aria-expanded', 'true');
              }
            });
        });
}

if (d.readyState == 'loading') {
        d.addEventListener('DOMContentLoaded', function() {
            domReadyFunctions();
        });
    } else {
        domReadyFunctions();
    }
})(window, document);